import { Auth, Amplify, Hub } from "aws-amplify";
import { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import {
	Authenticator,
	useTheme,
	View,
	Image,
	Text,
} from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import awsExports from "./aws-exports";

import PlotlogicLogo from "./assets/PLOTLOGIC_LOGO_MASTER_RGB.png";
import Alert from 'react-bootstrap/Alert';

import Navigation from "./components/navigation";
import QC from "./pages/qc";


Amplify.configure(awsExports);

export default function App() {

	const [authGroups, setAuthGroups] = useState([]);
	const qc_app = authGroups.includes("QC_APP");

	function environmentBanner() {
		
		if (process.env.REACT_APP_ENV_TYPE === 'UAT') {
			let string = `User Acceptance Testing (v${process.env.REACT_APP_RELEASE_VERSION})`;
			return (
			  <Alert variant='info' style={{textAlign: 'center'}}>{string}</Alert>
			) 
		
		} else if (process.env.REACT_APP_ENV_TYPE === 'SIT') {
		  let string = `System Integration Testing (v${process.env.REACT_APP_RELEASE_VERSION})`;
		  return (
			<Alert variant='warning' style={{textAlign: 'center'}}>{string}</Alert>
		  )
		}  else if (process.env.REACT_APP_ENV_TYPE === 'DEV') {
			let string = `DEV (v${process.env.REACT_APP_RELEASE_VERSION})`;
			return (
			  <Alert variant='info' style={{textAlign: 'center'}}>{string}</Alert>
			)
		  } else {
		  return ''
		}
	}
	useEffect(() => {
	async function check_user_privilege() {
	 try {
		const session = await Auth.currentSession();
		if (session) {
			const payload = session.getAccessToken().decodePayload();
			const cognito_groups = payload["cognito:groups"];
			// Check if user has been assigned to a group
			if(cognito_groups !== undefined || cognito_groups.length > 0){
			setAuthGroups(cognito_groups);
			}
		}
	} catch (error) {
		setAuthGroups([]);
		}
	}
	Hub.listen('auth', check_user_privilege)
	check_user_privilege();
	},[]);


	function UnAuthScreen() {

		return (
		<Container style={{ marginTop: "15px", marginBottom: "5px" }}>
			<h1 style={{ textAlign: "center" }}> Authentication error</h1>
				<div style={{ textAlign: "center" }}>
					You do not have authorization to use this application. Please contact your administrator.
				</div>
		</Container>
		);
	}

	return (
		<Authenticator
			components={{
				Header() {
					const { tokens } = useTheme();
					return (
						<View textAlign="center" padding={tokens.space.large}>
							<Image
								alt="Plotlogic Logo"
								src={PlotlogicLogo}
								style={{ width: "60%", height: "60%" }}
							/>
						</View>
					);
				},
				Footer() {
					const { tokens } = useTheme();
					return (
						<View textAlign="center" padding={tokens.space.large}>
							<Text color={tokens.colors.neutral[80]}>
								&copy; All Rights Reserved
							</Text>
						</View>
					);
				},
			}}
		>
			{({ signOut, user }) => (
				<>
					<Navigation signOut={signOut} user={user} />
					{process.env.REACT_APP_ENV_TYPE ? environmentBanner() : ''}

					{qc_app ?
            			<QC user={user} />
						:
            			<UnAuthScreen />
          			}	

				</>
			)}
		</Authenticator>
	);
}